import styled from 'styled-components';

export const UploadWrapperDiv = styled.div`
  &&& .ant-upload-list-item-card-actions {
    position: absolute;
    right: 0;
    opacity: 1;
  }
`;
